var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtsSector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 64,
    viewBox: "0 0 80 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40V12C0 7.58125 3.58125 4 8 4H48C52.4125 4 56 7.58125 56 12V40C56 44.4125 52.4125 48 48 48H37.1625L39.1625 54H45C46.6625 54 48 55.3375 48 57C48 58.6625 46.6625 60 45 60H11C9.34375 60 8 58.6625 8 57C8 55.3375 9.34375 54 11 54H16.8375L18.8375 48H8C3.58125 48 0 44.4125 0 40ZM48 10H8C6.895 10 6 10.895 6 12V40C6 41.1 6.895 42 8 42H48C49.1 42 50 41.1 50 40V12C50 10.895 49.1 10 48 10ZM32.8375 54L30.8375 48H25.1625L23.1625 54H32.8375ZM60 10C60 6.68625 62.6875 4 66 4H74C77.3125 4 80 6.68625 80 10V54C80 57.3125 77.3125 60 74 60H66C62.6875 60 60 57.3125 60 54V10ZM66 14H74V10H66V14ZM66 20V24H74V20H66ZM70 38C72.2125 38 74 39.7875 74 42V30H66V42C66 39.7875 67.7875 38 70 38ZM66 54H74V42C74 44.2125 72.2125 46 70 46C67.7875 46 66 44.2125 66 42V54Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtsSector);
export default __webpack_public_path__ + "static/media/vtsSector.40fce9294de264c98c2718a7a65508db.svg";
export { ForwardRef as ReactComponent };